<div class="container my-4">
	<h2>Rapport d’activité</h2>

	<!-- Sélection de la période -->
	<form class="row g-3 align-items-end mb-4">
		<div class="col-md-4">
			<label for="startDate" class="form-label">Date de début</label>
			<input
				type="date"
				id="startDate"
				class="form-control"
				[(ngModel)]="startDate"
				name="startDate"
				required
			/>
		</div>
		<div class="col-md-4">
			<label for="endDate" class="form-label">Date de fin</label>
			<input
				type="date"
				id="endDate"
				class="form-control"
				[(ngModel)]="endDate"
				name="endDate"
				required
			/>
		</div>
		<div class="col-md-4 d-flex gap-2">
			<button type="button" class="btn btn-primary" (click)="chargerRapport()">
				Afficher le rapport
			</button>
			<button
				type="button"
				class="btn btn-outline-success"
				(click)="exportCSV()"
				[disabled]="!rapport.length"
			>
				<i class="bi bi-filetype-csv"></i> Export CSV
			</button>
			<button
				type="button"
				class="btn btn-outline-danger"
				(click)="exportPDF()"
				[disabled]="!rapport.length"
			>
				<i class="bi bi-filetype-pdf"></i> Export PDF
			</button>
		</div>
	</form>

	<div *ngIf="isLoading" class="my-4">
		<app-loading></app-loading>
	</div>

	<!-- Tableau de rapport -->
	<div class="table-responsive" *ngIf="rapport.length">
		<table class="table table-bordered text-center">
			<thead class="table-secondary">
				<tr>
					<th rowspan="2">ETP CONCERNÉ</th>
					<th rowspan="2">Service</th>
					<th rowspan="2">N° de demande(s) DH</th>
					<th colspan="3">
						Période : {{ startDate | date : 'dd/MM/yyyy' }} -
						{{ endDate | date : 'dd/MM/yyyy' }}
					</th>
				</tr>
				<tr>
					<th>Nombre d'A/R</th>
					<th>Ville(s) - n° Département</th>
					<th>Kilomètres parcourus</th>
					<!-- <th>Temps de face à face</th> -->
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ligne of rapport">
					<td>{{ ligne.etp }}</td>
					<td>{{ ligne.service }}</td>
					<td>{{ ligne.idDemandDH }}</td>
					<td>{{ ligne.nbrAR }}</td>
					<td>{{ ligne.villes }}</td>
					<td>{{ ligne.km | number : '1.2-2' }} km</td>
					<!-- <td>{{ ligne.faceAFaceHHMM }}</td> -->
				</tr>
			</tbody>
		</table>
	</div>

	<div
		*ngIf="!rapport.length && rapportLoaded"
		class="alert alert-warning text-center mt-4"
	>
		Aucune donnée trouvée pour la période sélectionnée.
	</div>
</div>
